module.exports = window["nab"]["components"];